import { PropsWithChildren, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

const TemplatesCategoryItem = ({
  isSelected,
  children,
  onClick,
}: PropsWithChildren<{ isSelected: boolean; onClick: () => void }>): ReactNode => {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        `flex w-full justify-start rounded-lg px-5 py-2.5 whitespace-nowrap ring-brand-primary ring-offset-2 outline-hidden main-transition-colors focus-visible:ring-2`,
        isSelected
          ? 'bg-brand-primary text-background-secondary'
          : `text-text-primary hover:text-brand-primary`,
      )}
    >
      {children}
    </button>
  )
}

export default TemplatesCategoryItem
